/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Stack, SxProps, Theme } from "@mui/material";
import { desktopNavStyle } from "@/src/components/Header/DesktopNav/desktopNavStyle";
import { NavigationItemTypes } from "@/src/types/Navigation.ts";
import NavItem from "@/src/components/Header/NavItem/NavItem.tsx";

export type DesktopNavProps = {
  items?: NavigationItemTypes[] | null;
  sx?: SxProps<Theme>;
};

export default function DesktopNav({ items, sx }: DesktopNavProps) {
  return (
    <Box component={"nav"} sx={sx}>
      <Stack component={"ul"} direction={"row"} sx={desktopNavStyle.desktopNav}>
        {items?.map((itemProps) => {
          return <NavItem key={itemProps.label + itemProps.type} {...itemProps} />;
        })}
      </Stack>
    </Box>
  );
}
